import React, { useState } from "react";
import sparklePurple from "~/images/sparkle-purple.svg";
import ResultDescription from "./ResultDescription";
import { generateSeoTitle } from "../../api/freeToolsApis";
import FreeToolsLayout from "./FreeToolsLayout";
import GenerateResults from "../shared/GenerateResults";
const SeoTitleGenerator = () => {
  const [content, setContent] = useState("");
  const [description, setDescription] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showResult, setShowResult] = useState(false);

  const handleGenerate = async () => {
    if (!content.trim()) {
      setError("Please enter some content first");
      setShowResult(false);
      return;
    }

    setLoading(true);
    setError("");
    setShowResult(false);

    try {
      const response = await generateSeoTitle(content);
      if (response.data.seo_title) {
        setLoading(false);
        setDescription(response.data.seo_title);
        setCharCount(response.data.seo_title.length);
        setShowResult(true);
      } else {
        throw new Error(response.data.error || "Failed to generate description");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const getButtonText = () => {
    if (loading) return "Generating...";
    if (description) return "Generate Again";
    return "Generate";
  };
  return (
    <FreeToolsLayout mainHeading="AI SEO Title Generator" subHeading="Create engaging SEO titles for your web pages using AI">
      <div className="bg-white/70 rounded-[20px] p-[26px] shadow-md shadow-[#6248fe1f] relative min-h-[200px]">
        <textarea
          id="inputText"
          value={content}
          onChange={(e) => {
            setContent(e.target.value);
          }}
          className="w-full pr-16 bg-transparent border-none outline-none resize-none text-sm min-h-[120px] text-black placeholder-[#707070] focus:ring-0"
          placeholder="Enter your page content or topic here..."
        ></textarea>
        <GenerateResults handleGenerate={handleGenerate} loading={loading} text={getButtonText()} />
      </div>
      {error && <div className="text-red-600 text-sm px-2">{error}</div>}
      {showResult && (
        <div>
          <div className="flex items-center justify-center mb-4">
            <img src={sparklePurple} />
          </div>
          <ResultDescription description={description} charCount={charCount} totalCount="60" />
        </div>
      )}
    </FreeToolsLayout>
  );
};
export default SeoTitleGenerator;
